"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectType = void 0;
var EffectType;
(function (EffectType) {
    EffectType[EffectType["Death"] = 0] = "Death";
    EffectType[EffectType["Damage"] = 1] = "Damage";
    EffectType[EffectType["Healing"] = 2] = "Healing";
    EffectType[EffectType["AttributeIncrease"] = 3] = "AttributeIncrease";
    EffectType[EffectType["AttributeDecrease"] = 4] = "AttributeDecrease";
    EffectType[EffectType["TurnMeterIncrease"] = 5] = "TurnMeterIncrease";
    EffectType[EffectType["TurnMeterDecrease"] = 6] = "TurnMeterDecrease";
    EffectType[EffectType["Block"] = 7] = "Block";
    EffectType[EffectType["MaxAttributeIncrease"] = 8] = "MaxAttributeIncrease";
    EffectType[EffectType["MaxAttributeDecrease"] = 9] = "MaxAttributeDecrease";
    EffectType[EffectType["DoTDamage"] = 10] = "DoTDamage";
    EffectType[EffectType["HoTHealing"] = 11] = "HoTHealing";
    EffectType[EffectType["AvoidDeath"] = 12] = "AvoidDeath";
    EffectType[EffectType["LikeABoss"] = 13] = "LikeABoss";
    EffectType[EffectType["LinkedEffects"] = 14] = "LinkedEffects";
    EffectType[EffectType["PassiveBuff"] = 15] = "PassiveBuff";
    EffectType[EffectType["LinkedEventHandler"] = 16] = "LinkedEventHandler";
    EffectType[EffectType["ReciprocateAttack"] = 17] = "ReciprocateAttack";
    EffectType[EffectType["ReciprocateDeath"] = 18] = "ReciprocateDeath";
    EffectType[EffectType["LinkedVfx"] = 19] = "LinkedVfx";
    EffectType[EffectType["MaxAttributePercentDecrease"] = 20] = "MaxAttributePercentDecrease";
    EffectType[EffectType["MaxAttributePercentIncrease"] = 21] = "MaxAttributePercentIncrease";
    EffectType[EffectType["Burning"] = 100] = "Burning";
    EffectType[EffectType["Chill"] = 101] = "Chill";
    EffectType[EffectType["Bleeding"] = 102] = "Bleeding";
    EffectType[EffectType["Poisoned"] = 103] = "Poisoned";
    EffectType[EffectType["Curse"] = 104] = "Curse";
    EffectType[EffectType["Diseased"] = 105] = "Diseased";
    EffectType[EffectType["BurningLight"] = 106] = "BurningLight";
    EffectType[EffectType["EternalDarkness"] = 107] = "EternalDarkness";
    EffectType[EffectType["BleedImmunity"] = 108] = "BleedImmunity";
    EffectType[EffectType["Arcing"] = 109] = "Arcing";
    EffectType[EffectType["Convulsions"] = 110] = "Convulsions";
    EffectType[EffectType["SeedOfDarkness"] = 111] = "SeedOfDarkness";
    EffectType[EffectType["Ruination"] = 112] = "Ruination";
    EffectType[EffectType["Swarmed"] = 113] = "Swarmed";
    EffectType[EffectType["Leech"] = 114] = "Leech";
    EffectType[EffectType["MeltedArmor"] = 115] = "MeltedArmor";
    EffectType[EffectType["SignaExDiris"] = 116] = "SignaExDiris";
    EffectType[EffectType["BadLuck"] = 117] = "BadLuck";
    EffectType[EffectType["GlassCannon"] = 118] = "GlassCannon";
    EffectType[EffectType["HuntersSupremacy"] = 119] = "HuntersSupremacy";
    EffectType[EffectType["KillingMachine"] = 120] = "KillingMachine";
    EffectType[EffectType["MasterSharpshooter"] = 121] = "MasterSharpshooter";
    EffectType[EffectType["MasterOfPoisons"] = 122] = "MasterOfPoisons";
    EffectType[EffectType["MarkOfTheKunir"] = 123] = "MarkOfTheKunir";
    EffectType[EffectType["Withering"] = 124] = "Withering";
    EffectType[EffectType["Mirage"] = 125] = "Mirage";
    EffectType[EffectType["PoisonImmunity"] = 126] = "PoisonImmunity";
    EffectType[EffectType["Dizzy"] = 127] = "Dizzy";
    EffectType[EffectType["Taunted"] = 128] = "Taunted";
    EffectType[EffectType["Regeneration"] = 200] = "Regeneration";
    EffectType[EffectType["AttributeBasedHealing"] = 201] = "AttributeBasedHealing";
    EffectType[EffectType["Vulnerability"] = 500] = "Vulnerability";
    EffectType[EffectType["Haste"] = 501] = "Haste";
    EffectType[EffectType["Slow"] = 502] = "Slow";
    EffectType[EffectType["Stun"] = 503] = "Stun";
    EffectType[EffectType["Darkness"] = 504] = "Darkness";
    EffectType[EffectType["Unblockable"] = 505] = "Unblockable";
    EffectType[EffectType["DamageReflect"] = 506] = "DamageReflect";
    EffectType[EffectType["SplitDamageReflect"] = 507] = "SplitDamageReflect";
    EffectType[EffectType["CurseSiphon"] = 508] = "CurseSiphon";
    EffectType[EffectType["Fear"] = 509] = "Fear";
    EffectType[EffectType["EffectOnHit"] = 510] = "EffectOnHit";
    EffectType[EffectType["EffectOnDeath"] = 511] = "EffectOnDeath";
    EffectType[EffectType["Revenge"] = 512] = "Revenge";
    EffectType[EffectType["DamageAbsorb"] = 513] = "DamageAbsorb";
    EffectType[EffectType["Mirror"] = 514] = "Mirror";
    EffectType[EffectType["DamageReciprocate"] = 515] = "DamageReciprocate";
    EffectType[EffectType["DramaticEndings"] = 516] = "DramaticEndings";
    EffectType[EffectType["CommandingPresence"] = 517] = "CommandingPresence";
    EffectType[EffectType["Redirect"] = 518] = "Redirect";
    EffectType[EffectType["Echo"] = 519] = "Echo";
    EffectType[EffectType["EchoStack"] = 520] = "EchoStack";
    EffectType[EffectType["IntimidationOfTheKing"] = 521] = "IntimidationOfTheKing";
    EffectType[EffectType["Fade"] = 522] = "Fade";
    EffectType[EffectType["OutOfTime"] = 523] = "OutOfTime";
    EffectType[EffectType["Meltdown"] = 524] = "Meltdown";
    EffectType[EffectType["AuraOfTheConqueror"] = 525] = "AuraOfTheConqueror";
    EffectType[EffectType["RavynsTouch"] = 526] = "RavynsTouch";
    EffectType[EffectType["Roar"] = 527] = "Roar";
    EffectType[EffectType["IndestructibleBattleCry"] = 528] = "IndestructibleBattleCry";
    EffectType[EffectType["Possessed"] = 529] = "Possessed";
    EffectType[EffectType["GoodJuju"] = 530] = "GoodJuju";
    EffectType[EffectType["Transference"] = 531] = "Transference";
    EffectType[EffectType["Hoodoo"] = 532] = "Hoodoo";
    EffectType[EffectType["Damned"] = 533] = "Damned";
    EffectType[EffectType["ImpenetrableDefense"] = 534] = "ImpenetrableDefense";
    EffectType[EffectType["DrunkenClarity"] = 535] = "DrunkenClarity";
    EffectType[EffectType["DeferDeath"] = 536] = "DeferDeath";
    EffectType[EffectType["DeferredDeath"] = 537] = "DeferredDeath";
    EffectType[EffectType["Radiance"] = 538] = "Radiance";
    EffectType[EffectType["DropTheHammer"] = 539] = "DropTheHammer";
    EffectType[EffectType["ShockShield"] = 540] = "ShockShield";
    EffectType[EffectType["Starbreaker"] = 541] = "Starbreaker";
    EffectType[EffectType["Halo"] = 542] = "Halo";
    EffectType[EffectType["Wrath"] = 543] = "Wrath";
    EffectType[EffectType["Weakness"] = 544] = "Weakness";
    EffectType[EffectType["LightningBond"] = 545] = "LightningBond";
    EffectType[EffectType["BriarBulwark"] = 546] = "BriarBulwark";
    EffectType[EffectType["StingingSwarm"] = 547] = "StingingSwarm";
    EffectType[EffectType["Frosty"] = 548] = "Frosty";
    EffectType[EffectType["Summoned"] = 549] = "Summoned";
    EffectType[EffectType["NaturesRegeneration"] = 550] = "NaturesRegeneration";
    EffectType[EffectType["ForestsRejuvenation"] = 551] = "ForestsRejuvenation";
    EffectType[EffectType["TreantForm"] = 552] = "TreantForm";
    EffectType[EffectType["Wildfire"] = 553] = "Wildfire";
    EffectType[EffectType["ArcaneResidue"] = 554] = "ArcaneResidue";
    EffectType[EffectType["ObidiahsBlessing"] = 555] = "ObidiahsBlessing";
    EffectType[EffectType["StolenStats"] = 560] = "StolenStats";
    EffectType[EffectType["HotStreak"] = 561] = "HotStreak";
    EffectType[EffectType["LoanShark"] = 562] = "LoanShark";
    EffectType[EffectType["LoanedStats"] = 563] = "LoanedStats";
    EffectType[EffectType["ElementalBlessingFire"] = 564] = "ElementalBlessingFire";
    EffectType[EffectType["ElementalBlessingFrost"] = 565] = "ElementalBlessingFrost";
    EffectType[EffectType["ElementalBlessingEarth"] = 566] = "ElementalBlessingEarth";
    EffectType[EffectType["ElementalBlessingLightning"] = 567] = "ElementalBlessingLightning";
    EffectType[EffectType["SonicPulse"] = 568] = "SonicPulse";
    EffectType[EffectType["Charmed"] = 569] = "Charmed";
    EffectType[EffectType["AncientDecay"] = 570] = "AncientDecay";
    EffectType[EffectType["AncientDecayTick"] = 571] = "AncientDecayTick";
    EffectType[EffectType["EmperorsRegeneration"] = 572] = "EmperorsRegeneration";
    EffectType[EffectType["EmperorsWeakness"] = 573] = "EmperorsWeakness";
    EffectType[EffectType["OldOrcishWays"] = 574] = "OldOrcishWays";
    EffectType[EffectType["HitsLikeAMackTrk"] = 575] = "HitsLikeAMackTrk";
    EffectType[EffectType["Confused"] = 576] = "Confused";
    EffectType[EffectType["Clowned"] = 577] = "Clowned";
    EffectType[EffectType["RecentlyStunned"] = 578] = "RecentlyStunned";
    EffectType[EffectType["StunImmunity"] = 579] = "StunImmunity";
    EffectType[EffectType["DamageAmplify"] = 580] = "DamageAmplify";
    EffectType[EffectType["Invulnerable"] = 581] = "Invulnerable";
    EffectType[EffectType["FrostBitten"] = 582] = "FrostBitten";
    EffectType[EffectType["TauntImmunity"] = 583] = "TauntImmunity";
    EffectType[EffectType["Resurrect"] = 600] = "Resurrect";
    EffectType[EffectType["Animation"] = 1000] = "Animation";
    EffectType[EffectType["RemoveEffectsOfType"] = 2000] = "RemoveEffectsOfType";
    EffectType[EffectType["RemoveSpecificEffect"] = 2001] = "RemoveSpecificEffect";
    EffectType[EffectType["DisableAbility"] = 2002] = "DisableAbility";
    EffectType[EffectType["EnableAbility"] = 2003] = "EnableAbility";
    EffectType[EffectType["Passive_SigilOfBlood"] = 3000] = "Passive_SigilOfBlood";
    EffectType[EffectType["Passive_SigilOfDamnation"] = 3001] = "Passive_SigilOfDamnation";
    EffectType[EffectType["Passive_SigilOfTheDamken"] = 3002] = "Passive_SigilOfTheDamken";
    EffectType[EffectType["Passive_CommandingPresence"] = 3003] = "Passive_CommandingPresence";
    EffectType[EffectType["Passive_DramaticEndings"] = 3004] = "Passive_DramaticEndings";
    EffectType[EffectType["Passive_WatchThemDie"] = 3005] = "Passive_WatchThemDie";
    EffectType[EffectType["Passive_Enrage"] = 3006] = "Passive_Enrage";
    EffectType[EffectType["Passive_ReflectiveCurse"] = 3007] = "Passive_ReflectiveCurse";
    EffectType[EffectType["FlamesOfWar"] = 3008] = "FlamesOfWar";
    EffectType[EffectType["Berserking"] = 3009] = "Berserking";
    EffectType[EffectType["CharmImmunity"] = 3010] = "CharmImmunity";
    EffectType[EffectType["Vengeance"] = 3011] = "Vengeance";
    EffectType[EffectType["GazeOfPetrification"] = 3012] = "GazeOfPetrification";
    EffectType[EffectType["Stardust"] = 3013] = "Stardust";
    EffectType[EffectType["Apex"] = 3014] = "Apex";
    EffectType[EffectType["ApplyVfx"] = 4000] = "ApplyVfx";
    // cyndine...
    EffectType[EffectType["CyndineSoulHarvest"] = 5000] = "CyndineSoulHarvest";
    EffectType[EffectType["SoulDrain"] = 5001] = "SoulDrain";
    EffectType[EffectType["Bloodlust"] = 5002] = "Bloodlust";
    EffectType[EffectType["Dampened"] = 5003] = "Dampened";
    EffectType[EffectType["BloodSignet"] = 5004] = "BloodSignet";
    // Cerberus
    EffectType[EffectType["HellScorned"] = 5010] = "HellScorned";
    // Aspect of Kaboom
    EffectType[EffectType["Windswept"] = 6103] = "Windswept";
    // headless horseman
    EffectType[EffectType["UndeadResolve"] = 6105] = "UndeadResolve";
    // bard
    EffectType[EffectType["HealingRhythm"] = 6200] = "HealingRhythm";
})(EffectType = exports.EffectType || (exports.EffectType = {}));
